import txBase, {TO_SAVE_BASE, KEY, initState as baseState} from '../../../vuex/tx-base';
import {registerModule} from '../../../vuex/helpers/vuex-pathify-register-module';
import {sync, make} from 'vuex-pathify'

import defaultMainText from '../data/mainText'
import deepmerge from "deepmerge";
import templateResetMutation from "../../../vuex/helpers/template-reset-mutation";
import defaultState from "../../../vuex/helpers/default-state";

const STORE_NAMESPACE = 'image-template';


let mapData = window[KEY];

let productDefault = {
    mapSize: "30x40cm",
    mainText: defaultMainText,
    mainTextStyle: 'font-1',
    secondaryText: '- image template',
    secondaryTextStyle: 'font-6',
    cropImg: '',
}


export const initState = (mapData) => {
    return defaultState(mapData, productDefault)
}

let vuexModule = {};
vuexModule.state = initState(mapData);

vuexModule.mutations = {
    ...make.mutations(vuexModule.state),
    reset: templateResetMutation(initState, STORE_NAMESPACE)
}

const EXCLUDE_FROM_SAVE = [];

let SAVE_PARAMS = [
    ...TO_SAVE_BASE,
    ...Object.keys(vuexModule.state).filter(item => !!EXCLUDE_FROM_SAVE.findIndex(exclude => item === exclude))
]

let extendedModule = deepmerge(txBase, vuexModule);

function members() {
    const {state} = extendedModule;
    let computed = {};
    for (let [key, value] of Object.entries(state)) {
        computed[key] = sync(`${STORE_NAMESPACE}/${key}`)
    }

    computed.toSaveParams = function () {
        let toSaveParams = {};
        for (let key of SAVE_PARAMS) {
            toSaveParams[key] = this[key]
        }
        return toSaveParams
    };

    return {
        computed,
    }
}


export default ImageTemplateModule => {
    return registerModule(STORE_NAMESPACE, extendedModule, members);
}